import { IS_PROD_ENV } from "@vahak/core/dist/_services/const";
import { COMPANY_DETAILS } from "@vahak/core/dist/constants/companyDetails";

interface baseProps {
    mktType: "load" | "lorry";
    source: string;
    destination: string;
    entityId: number | string;
    oppcmpid: number | string;
    referralCode: string;
    utm_source: string;
    utm_medium: string;
    utm_campaign: string;
}

const SHORT_LINK_DEV = "https://vahaktest.page.link";
const SHORT_LINK_PROD = "https://vahak.page.link";
export const getShortLinkBaseUrl = () => {
    return IS_PROD_ENV ? SHORT_LINK_PROD : SHORT_LINK_DEV;
};
export const getWebsiteBaseUrl = () => {
    return IS_PROD_ENV ? COMPANY_DETAILS.website : COMPANY_DETAILS.stagingLink;
};

export const generateMarketplaceCardLongDynamicLink = ({
    mktType,
    source,
    destination,
    entityId,
    oppcmpid,
    referralCode,
    utm_source,
    utm_medium,
    utm_campaign
}: baseProps) => {
    const ID = mktType === "load" ? `loadbid=${entityId}` : `lorrybid=${entityId}`;

    const destinationLink = `${getWebsiteBaseUrl()}/marketplace/${mktType}/${source ? source : ""}${
        destination ? "-to-" + destination : ""
    }?${ID}${referralCode ? "&referral_code=" + referralCode : ""}${
        oppcmpid ? "&oppcmpid=" + oppcmpid : ""
    }&r=load|${entityId}&u_i=${oppcmpid}&utm_source=${utm_source}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}&p=1`;

    const longLink = `${getShortLinkBaseUrl()}/?link=${destinationLink}&apn=search.find.lorries.invite.transporter.add.lorries.deliveries.codenicely.search.vahak&afl=${destinationLink}`;

    return destinationLink;
};
